import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import SpriteComponent from '../../../Component/Render/Sprite';
import { delay } from '../../../Utility/Task/TaskQueue';

export interface IContainerFadeInMeta {
    initialDelay?: number;
    duration?: number;
}

export class ContainerFadeIn extends AnimationClip<IContainerFadeInMeta> {
    public *execute(
        /**
         * GameObject must have SpriteComponent or Renderable component
         */
        gameObject: GameObject,
        meta?: IContainerFadeInMeta
    ): IterableIterator<number> {
        try {
            const renderable: Renderable = gameObject.getComponent(Renderable);
            let sprite: SpriteComponent = null;
            if(!renderable) {
                sprite = gameObject.getComponent(SpriteComponent);
            }

            (renderable || sprite).visible = true;
            (renderable || sprite).alpha = 0;

            const fadeInTween: Tween = this.getTween(renderable || sprite);

            yield* delay(meta?.initialDelay || 0);
            fadeInTween.to({ alpha: 1 }, meta?.duration || 300).easing(Easing.Linear.None);
            yield* this.startTween(fadeInTween);
        } catch (e) {
            console.error(e);
        }
    }
}
